import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import styles from './css/TopLeaderboardAdOptions.styl';
import {AdController, AdService} from 'legacy-advertising';
import classNames from 'classnames';
import NearbyFuneralHomes from '../NearbyFuneralHomes';

export class TopLeaderboardAdOptions extends Component {
  static propTypes = {
    adService: PropTypes.shape({type: PropTypes.instanceOf(AdService)})
      .isRequired,
    shortVersion: React.PropTypes.bool,
    nearbyFuneralHomes: React.PropTypes.array,
    planning: React.PropTypes.bool,
  };

  static defaultProps = {
    shortVersion: false,
  };

  renderNearbyFuneralHomesAd() {
    return (
      <div className="TopLeaderboardNearbyHomes">
        <NearbyFuneralHomes funeralHomes={this.props.nearbyFuneralHomes} />
      </div>
    );
  }

  renderTopLeaderboardAd() {
    return (
      <div className={styles.TopLeaderboardAd}>
        <div className={styles.AdvertisementCopy}>Advertisement</div>
        <AdController
          adService={this.props.adService}
          adSize={[[728, 90], [320, 50], 'fluid']}
          pageName="fh-profile"
          positionId="display-top-1"
          responsiveSizeMap="mapping728x90Header"
        />
      </div>
    );
  }

  render() {
    const {shortVersion, planning} = this.props;

    return (
      <div
        className={classNames(
          styles.TopLeaderboardAdOptions,
          shortVersion ? styles.ShortVersion : null
        )}
      >
        {planning
          ? this.renderNearbyFuneralHomesAd()
          : this.renderTopLeaderboardAd()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  nearbyFuneralHomes: state.nearbyFuneralHomesStore,
  planning: state.planningStore.isPlanning,
});

export default connect(mapStateToProps)(TopLeaderboardAdOptions);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/TopLeaderboardAdOptions/index.js